import { render, staticRenderFns } from "./GalacticCredits.vue?vue&type=template&id=162a93a4&scoped=true&"
import script from "./GalacticCredits.vue?vue&type=script&lang=js&"
export * from "./GalacticCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a93a4",
  null
  
)

export default component.exports